module.exports = __webpack_public_path__ + "img/laboratory_05.826fe797.png";